// components/utils/MandantErstellenForm.jsx

import React from "react";

const MandantErstellenForm = ({
  formData,
  handleChange,
  handleSubmit,
  loading,
  message,
  error,
  navigate
}) => {
  return (
    <div className="container mt-5">
      <div className="card shadow-sm mx-auto" style={{ maxWidth: "600px" }}>
        <div className="card-body">
          <h3 className="card-title text-center mb-4">Neuen Mandanten & Benutzer erstellen</h3>

          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Benutzername</label>
              <input
                type="text"
                name="username"
                className="form-control"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">E-Mail</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Passwort</label>
              <input
                type="password"
                name="password"
                className="form-control"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Vorname</label>
              <input
                type="text"
                name="vorname"
                className="form-control"
                value={formData.vorname}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Nachname</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            <div className="col-12">
              <label className="form-label">Mandantenname (optional)</label>
              <textarea
                name="mandant_name"
                className="form-control"
                rows="1"
                value={formData.mandant_name}
                onChange={handleChange}
              />
            </div>
            <div className="col-12 d-flex gap-2 mt-3">
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Erstelle..." : "Speichern"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => navigate("/admin")}
              >
                Zurück zum AdminPanel
              </button>
            </div>
          </form>

          {message && <div className="alert alert-success mt-3">{message}</div>}
          {error && <div className="alert alert-danger mt-3">{error}</div>}
        </div>
      </div>
    </div>
  );
};

export default MandantErstellenForm;
